export const profile = {
    name: 'Алексей Левенцов',
    nameLines: ['Алексей', 'Левенцов'],
    role: 'DevOps / Product Engineer',
    lead: 'Соединяю инфраструктурную экспертизу с продуктовой разработкой, LLM и агентными подходами.',
    summaryLead: 'Product Engineer с сильной DevOps-базой и опытом системного администрирования, эксплуатации корпоративных систем и автоматизации разработки.',
    summary: [
        'Сейчас работаю в банковском секторе. Основной фокус — продуктовая инженерия, плотная работа с LLM и агентная разработка.',
        'Инфраструктурный опыт помогает доводить решения до эксплуатации: от реализации и автоматизации до CI/CD, контейнеризации и сопровождения в Kubernetes.',
    ],
    facts: [
        { value: '14+ лет', label: 'в IT и инфраструктуре' },
        { value: 'DEV → PROD', label: 'полный цикл доставки' },
        { value: 'Kubernetes', label: 'эксплуатация сервисов' },
    ],
    contactLead: 'Предпочитаю удалённый формат. Быстрее всего отвечаю в Telegram или по электронной почте.',
    email: 'leventcov.a.v@gmail.com',
    telegramUrl: 'https://t.me/L_Alexeyka',
    telegramLabel: '@L_Alexeyka',
    location: 'Санкт-Петербург',
};

export const navigation = [
    { id: 'about', label: 'Обо мне' },
    { id: 'experience', label: 'Опыт' },
    { id: 'skills', label: 'Стек' },
    { id: 'projects', label: 'Проекты' },
    { id: 'education', label: 'Образование' },
    { id: 'contact', label: 'Контакты' },
];

export const competencies = [
    { number: '01', title: 'Product Engineering и AI', description: 'LLM, агентная разработка и инженерные решения с фокусом на продуктовый результат.' },
    { number: '02', title: 'Контейнерная среда', description: 'Развёртывание и сопровождение приложений в Docker и Kubernetes, настройка Helm и перенос сервисов.' },
    { number: '03', title: 'Инфраструктура', description: 'Эксплуатация Linux, виртуальных сред, хранилищ и мониторинга, проведение инфраструктурных миграций.' },
    { number: '04', title: 'Автоматизация', description: 'Инструменты на Python, Bash и Ansible для устранения ручных операций и снижения числа ошибок.' },
];

export const skillGroups = [
    { title: 'AI Engineering', items: ['LLM', 'Agentic development', 'AI-assisted workflows'] },
    { title: 'Delivery', items: ['GitLab CI', 'Jenkins', 'Docker', 'Docker Compose', 'Helm'] },
    { title: 'Platform', items: ['Kubernetes', 'Linux', 'Ansible', 'VMware ESXi', 'oVirt', 'Proxmox'] },
    { title: 'Data', items: ['Greenplum', 'Arenadata DB', 'PostgreSQL', 'Oracle', 'MS SQL'] },
    { title: 'Automation', items: ['Python', 'Bash', 'PowerShell', 'REST API', 'Git'] },
];

export const projects = [
    { kind: 'Статья', title: 'Автоматизация развёртывания Kubernetes', description: 'Практический разбор подготовки стенда и воспроизводимой установки компонентов кластера.', url: 'https://habr.com/ru/articles/751582/' },
    { kind: 'Статья', title: 'React + Django: Hello World', description: 'Связываем клиентское React-приложение с Django-бэкендом на простом примере.', url: 'https://habr.com/ru/post/713490/' },
];

export const education = [
    { year: '2010', title: 'Специалист по защите информации', place: 'СибАДИ, Омск' },
    { year: '2005', title: 'Техник-программист', place: 'СРШБ, колледж' },
    { year: '2023', title: 'Jenkins и Kubernetes для DevOps', place: 'Udemy' },
    { year: '2021', title: 'Cisco CCNA', place: 'УЦ Микротест' },
];
